/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Profile = ({ color = '#304A3D', size = 16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 12c3.785 0 6.958 2.214 7.784 6H2.216c.826-3.786 3.999-6 7.784-6zM6 6c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4zm7.758 4.673A5.983 5.983 0 0016 6a6 6 0 10-9.758 4.673C2.583 12.048 0 15.445 0 20h20c0-4.555-2.583-7.952-6.242-9.327z"
      />
    </svg>
  )
}

Profile.propTypes = {
  color: string,
  size: number,
}

export default Profile
